import { vhostV1 } from "../app/funcoes";
import api from "./api";


export async function getEmpresa() {
     let config = {
    headers: {
      'Authorization': localStorage.getItem("token")
    }
  }

  try {
    const response = await api.post(
      vhostV1('webcash/Empresa/retornaEmpresa'),
      {},
      config
    );

    return response.data.dados;
  } catch (error) {
    console.error('Erro ao buscar empresa', error);
    throw error;
  }
}